import {
  PERFORMANCESCOREDETAIL_LOADING,
  GET_PERFORMANCESCOREDETAIL,
  GET_PERFORMANCESCOREDETAIL_SUCCESS,
  GET_PERFORMANCESCOREDETAIL_FAIL,
  ADD_PERFORMANCESCOREDETAIL_SUCCESS,
  ADD_PERFORMANCESCOREDETAIL_FAIL,
  DELETE_PERFORMANCESCOREDETAIL_SUCCESS,
  DELETE_PERFORMANCESCOREDETAIL_FAIL,
  UPDATE_PERFORMANCESCOREDETAIL_SUCCESS,
  UPDATE_PERFORMANCESCOREDETAIL_FAIL,
  PERFORMANCESCOREDETAIL_RESET
} from "./actionType";

const INIT_STATE = {
  performanceScoreDetails: [],
  error: {},
};

const PerformanceScoreDetail = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PERFORMANCESCOREDETAIL_SUCCESS:
      switch (action.payload.actionType) {
        case GET_PERFORMANCESCOREDETAIL:
          return {
            ...state,
            performanceScoreDetails: action.payload.data,
            isPerformanceScoreDetailCreated: false,
            isPerformanceScoreDetailSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_PERFORMANCESCOREDETAIL_FAIL:
      switch (action.payload.actionType) {
        case GET_PERFORMANCESCOREDETAIL_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isPerformanceScoreDetailCreated: false,
            isPerformanceScoreDetailSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_PERFORMANCESCOREDETAIL: {
      return {
        ...state,
        isPerformanceScoreDetailCreated: false,
        loading: true,
      };
    }

    case PERFORMANCESCOREDETAIL_LOADING: {
      return {
        ...state,
        isPerformanceScoreDetailCreated: false,
        loading: true,
      };
    }

    case ADD_PERFORMANCESCOREDETAIL_SUCCESS:
      return {
        ...state,
        isPerformanceScoreDetailCreated: true,
        loading: false,
        performanceScoreDetails: [action.payload.data, ...state.performanceScoreDetails],
      };

    case ADD_PERFORMANCESCOREDETAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_PERFORMANCESCOREDETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        isPerformanceScoreDetailCreated: true,
        performanceScoreDetails: state.performanceScoreDetails.filter(
          performanceScoreDetail => performanceScoreDetail.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_PERFORMANCESCOREDETAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_PERFORMANCESCOREDETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        isPerformanceScoreDetailCreated: true,
        performanceScoreDetails: state.performanceScoreDetails.map(performanceScoreDetail =>
          performanceScoreDetail.id.toString() === action.payload.data.id.toString() ? { ...performanceScoreDetail, ...action.payload.data } : performanceScoreDetail
        ),
      };

    case UPDATE_PERFORMANCESCOREDETAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case PERFORMANCESCOREDETAIL_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default PerformanceScoreDetail;